import { c as _c } from "react/compiler-runtime";
import { FaroTextButton } from "@components/common/faro-text-button";
import { DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useLocation } from "react-router-dom";
/** A single tab item shown in the vertical tabs */
export function TabItem(t0) {
  const $ = _c(12);
  const {
    label,
    isHidden,
    isSelected,
    routeId,
    trackingEventPageName
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const {
    search
  } = useLocation();
  if (isHidden) {
    return null;
  }
  const t1 = isSelected ? "primary.main" : "text.primary";
  const t2 = isSelected ? "bold" : "normal";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      mb: "24px",
      pl: "0px",
      color: t1,
      fontSize: DEFAULT_INPUT_FONT_SIZE,
      fontWeight: t2,
      justifyContent: "flex-start"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `../${routeId}${search}`;
  let t5;
  if ($[3] !== routeId || $[4] !== trackEvent || $[5] !== trackingEventPageName) {
    t5 = () => {
      trackEvent({
        name: trackingEventPageName,
        props: {
          tab: routeId
        }
      });
    };
    $[3] = routeId;
    $[4] = trackEvent;
    $[5] = trackingEventPageName;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== label || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <FaroTextButton key={label} sx={t3} shouldHideFocusingEffect={true} shouldHideHoveringEffect={true} to={t4} onClick={t5}>{label}</FaroTextButton>;
    $[7] = label;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}